function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "3");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: 3,
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Milestones---BG-Copy",
  stroke: "#00AEFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x: 0,
  y: 0,
  width: 38,
  height: 38,
  rx: 19
}), /*#__PURE__*/React.createElement("text", {
  id: "input-number-1",
  fontFamily: "Gotham-Bold, Gotham",
  fontSize: 18,
  fontWeight: "bold",
  fill: "#00AEFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 13.411,
  y: 25
}, "3"))));

var Svg3Milestone = function Svg3Milestone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3Milestone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3-milestone.8e5fc244.svg";
export { ForwardRef as ReactComponent };